import formatNumber from 'common/formatNumber';

import locales from './compliancePropertiesLocales';

export const legalAnnualTurnoverOptions = [
  {
    label: `${formatNumber(0)} - ${formatNumber(40000)}`,
    value: '0-39',
  },
  {
    label: `${formatNumber(40000)} - ${formatNumber(100000)}`,
    value: '40-99',
  },
  {
    label: `${formatNumber(100000)} - ${formatNumber(250000)}`,
    value: '100-249',
  },
  {
    label: `${formatNumber(250000)} - 1 ${locales.million}`,
    value: '250-999',
  },
  {
    label: `1 ${locales.million} - 3 ${locales.millionPlural}`,
    value: '1000-2999',
  },
  {
    label: `3 ${locales.millionPlural} - 10 ${locales.millionPlural}`,
    value: '3000-9999',
  },
  {
    label: `10 ${locales.millionPlural} - 100 ${locales.millionPlural}`,
    value: '10000-99999',
  },
  {
    label: locales.legalAnnualTurnoverMaxRange,
    value: `100000-*`,
  },
] as const;

export const legalNumberOfEmployeeRangeOptions = [
  { label: '0', value: '0' },
  { label: '1 - 9', value: '1-9' },
  { label: '10 - 99', value: '10-99' },
  { label: '100 - 249', value: '100-249' },
  {
    label: locales.legalNumberOfEmployeeMaxRange,
    value: '250-*',
  },
] as const;

export const formatLegalNumberOfEmployeeRange = (
  range: string | null,
): string | null => {
  if (!range) {
    return null;
  }

  const foundChoice = legalNumberOfEmployeeRangeOptions.find(
    ({ value }) => value === range,
  );

  if (foundChoice === undefined) {
    throw new Error(
      'Unrecognised number of legalNumberOfEmployeeRangeOptions value',
    );
  }

  return foundChoice.label;
};

export const formatLegalAnnualTurnOver = (
  turnover: string | null,
): string | null => {
  if (!turnover) {
    return null;
  }

  const foundChoice = legalAnnualTurnoverOptions.find(
    ({ value }) => value === turnover,
  );

  if (foundChoice === undefined) {
    throw new Error(
      `Unrecognised number of legalAnnualTurnoverOptions value: ${turnover}`,
    );
  }

  return foundChoice.label;
};
